export default () => {
  const sticky = document.getElementById('sticky');
  if (sticky) {
    import(/* webpackChunkName: "sticky" */ './sticky').then(({ default: Sticky }) => {
      Sticky('sticky');
    });
  }
};
